import { createReducer } from '@reduxjs/toolkit'
import { projectUsersActions } from '@store/reducers/manager/users/actions'
import type { ProjectUsersState } from '@store/reducers/manager/users/types'

export const initialProjectUsersState: ProjectUsersState = []

export const projectUsersReducer = createReducer<ProjectUsersState>(
  initialProjectUsersState,
  (builder) => {
    builder
      .addCase(projectUsersActions.addUsers, (state, { payload }) => {
        return payload.reduce(
          (acc, user) => {
            if (!acc.find((u) => u.id === user.id)) {
              acc.push(user)
            }

            return acc
          },
          [...state]
        )
      })
      .addCase(projectUsersActions.resetUsers, () => {
        return initialProjectUsersState
      })
  }
)
